import { useParams } from "react-router-dom";
import { useProductionStore } from "../../../stores/production";
import {
  getProductionBillingByMonth,
  getProductionByDepartement,
  timeSpentPerCustomer,
} from "../../../api/customerFile";
import { showToastError, showToastInfo } from "../../../services/toast";
import { getTimeByCollab, getUsersProductions } from "../../../api/users";
import { getProductionInvoices } from "../../../api/invoices";
import { getProductionByDepartment } from "../../../api/departments";
import { getPaymentsProduction } from "../../../api/payments";

const Send = () => {
  const { formData, setProduction2, setProduction, setIsLoading } = useProductionStore();
  const { id } = useParams();
  const handleSend = () => {
    setIsLoading(true);
    if (id === "1") {
      // Si le customer file est null ou undefined, on le met à 0 pour avoir tous les clients

      timeSpentPerCustomer(
        formData.idCustomerFile || 0,
        formData.startDate,
        formData.endDate
      )
        .then((res) => {
          setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });

    } else if (id === "2") {
      getProductionByDepartement(formData.idDepartment, formData.date)
        .then((res) => {
          // Trier les customerFiles par ordre alphabétique du name
          const sortedCustomerFiles = res.data.customerFiles.sort((a: any, b: any) => {
            return a.name.toString().localeCompare(b.name.toString());
          });
          
          // Garder la structure complète de l'objet avec customerFiles trié
          const sortedData = {
            ...res.data,
            customerFiles: sortedCustomerFiles
          };
              
          setProduction2(sortedData);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "3") {
      getUsersProductions(formData.startDate, formData.endDate)
        .then((res) => {
            setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "4") {
      getProductionBillingByMonth(formData.startDate, formData.endDate)
        .then((res) => {
            setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "5") {
      getProductionInvoices(formData.startDate, formData.endDate, formData.idDepartment || "")
        .then((res) => {
            setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "6") {
      getProductionByDepartment(formData.startDate, formData.endDate)
        .then((res) => {
            setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "7") {
      getTimeByCollab(formData.idUser, formData.date.split("-")[0])
        .then((res) => {
          if(res.data.length > 0) {
            setProduction(res.data);
          } else {
            showToastInfo("Aucune donnée trouvée pour l'année sélectionnée et l'utilisateur sélectionné.");
          }
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (id === "9") {
      getPaymentsProduction(formData.startDate, formData.endDate)
        .then((res) => {
          setProduction2(res.data);
        })
        .catch(() => {
          showToastError("Une erreur est survenue.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };

  return (
    <button
      className="w-auto bg-linear-to-br from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center"
      onClick={() => handleSend()}
    >
      Visualiser
    </button>
  );
};

export default Send;
